<div class="staticPage editor-page" style="text-align: justify;">
  <div class="p-grid">
    <div class="p-col-12">
      <h1 class="blueColor" style="text-align: center;">{{ 'how_to_buy' | translate }}</h1>
      <div class="gradientDivider"></div>
      <div class="content-from-editor" [innerHTML]="howBuyHtml.content"></div>
    </div>
  </div>
</div>
